module.exports = __webpack_public_path__ + "static/gallery6-b536edd9bff3f59a3212987477c203a2.png";